import { status } from 'skin/event/status';
import next from './next';

const master = (obj, ms, story, data, d, action) => {
	switch (obj.action) {
		case 'step': 
			return next(obj, ms, story, data, d, action);
		default:
			return status.action;
	}
}

export default master;
